import { AuthAction } from '@store/interfaces';
import { add, getUnixTime } from 'date-fns';
import Cookies from 'universal-cookie';

import { REFRESH_TOKEN_KEY, TOKEN_KEY, TOKEN_THRESHOLD_KEY, USER_TYPE } from './constants';
import ENV from './env';

export const setThreshold = (time: number): string =>
	getUnixTime(
		add(new Date(), {
			seconds: time || 3600
		})
	).toString();

export const handleItem = (key: string, value?: string): void => {
	if (value) {
		localStorage.setItem(key, value);
	} else {
		localStorage.removeItem(key);
	}
};

/* eslint-disable @typescript-eslint/no-non-null-assertion */
// SECURITY NOTE: Tokens in localStorage are vulnerable to XSS. Refresh tokens should be
// HttpOnly, Secure, SameSite cookies set by the backend. Current implementation keeps
// localStorage for compatibility but adds Secure cookie mirroring. Migrate to HttpOnly
// backend cookies + short-lived access tokens (4h) as per SECURITY_AUDIT_REPORT.
export const setItems = (data: AuthAction['payload']): void => {
	handleItem(TOKEN_KEY, data!.access_token);
	handleItem(TOKEN_THRESHOLD_KEY, setThreshold(data!.expiry_time!));
	handleItem(REFRESH_TOKEN_KEY, data!.refresh_token);
	handleItem(USER_TYPE, data!.user_type);
	const cookies = new Cookies('LOGIN', { domain: ENV.AUTH_BASE_DOMAIN });
	const isSecure = typeof window !== 'undefined' && window.location.protocol === 'https:';
	cookies.set(TOKEN_KEY, data!.access_token, {
		domain: ENV.AUTH_BASE_DOMAIN,
		expires: new Date(data!.expiry_time!),
		path: '/',
		secure: isSecure,
		sameSite: 'lax'
	});
	cookies.set(REFRESH_TOKEN_KEY, data!.refresh_token!, {
		domain: ENV.AUTH_BASE_DOMAIN,
		expires: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
		path: '/',
		secure: isSecure,
		sameSite: 'lax'
	});
	cookies.set(TOKEN_THRESHOLD_KEY, setThreshold(data!.expiry_time!), {
		domain: ENV.AUTH_BASE_DOMAIN,
		expires: new Date(data!.expiry_time!),
		path: '/',
		secure: isSecure,
		sameSite: 'lax'
	});
};
/* eslint-enable @typescript-eslint/no-non-null-assertion */

export const removeItems = (): void => {
	handleItem(TOKEN_KEY);
	handleItem(TOKEN_THRESHOLD_KEY);
	handleItem(REFRESH_TOKEN_KEY);

	const cookies = new Cookies('LOGIN', { domain: ENV.AUTH_BASE_DOMAIN });
	cookies.remove(TOKEN_KEY, { domain: ENV.AUTH_BASE_DOMAIN });
	cookies.remove(REFRESH_TOKEN_KEY, { domain: ENV.AUTH_BASE_DOMAIN });
	cookies.remove(TOKEN_THRESHOLD_KEY, { domain: ENV.AUTH_BASE_DOMAIN });
	cookies.remove(USER_TYPE, { domain: ENV.AUTH_BASE_DOMAIN });
};
